const server = 'https://laundry.ecocleanbudva.com:1455/api/v1/';

export const environment = {
    production: true,

    server: server
};
